import styled from 'styled-components';

export default styled.div`
  padding: 30px 30px;
`;
